import { useCallback, useMemo } from 'react';

import type { FormInstance } from '@arco-design/web-react';

import type { VendorDeviceMeta } from '../../vendorDevice';
import { isDiskPricingActive, syncVendorDeviceMetaToInnerForm } from '../../vendorDevice';
import type { UseDiskPricingSyncOptions } from '../types';
import { syncDiskListPricingToInnerForm } from '../utils';

/** 磁盘计价同步：pricingActive 判定 + innerForm 厂商设备字段同步 */
export function useDiskPricingSync(options?: UseDiskPricingSyncOptions) {
  const pricingActive = useMemo(() => isDiskPricingActive(options), [options?.billModelId, options?.resourceCode]);

  const syncItemPricing = useCallback(
    (form: FormInstance, fieldPrefix: string, meta?: VendorDeviceMeta | null) => {
      if (!pricingActive) return;
      syncVendorDeviceMetaToInnerForm(form, fieldPrefix, meta);
    },
    [pricingActive],
  );

  const syncListPricing = useCallback(
    <T>(form: FormInstance, listPath: string, list: T[], filter?: (item: T, index: number) => boolean) => {
      if (!pricingActive) return;
      syncDiskListPricingToInnerForm(form, listPath, list, filter);
    },
    [pricingActive],
  );

  const clearItemPricing = useCallback(
    (form: FormInstance, fieldPrefix: string) => {
      syncItemPricing(form, fieldPrefix, undefined);
    },
    [syncItemPricing],
  );

  return { pricingActive, syncItemPricing, syncListPricing, clearItemPricing };
}
